<template>
  <div class="avatarSmall">
      <div class="avatar-main-xs" id="avatar-main-id-xs" @click="expandirAvatar_xs"  @mouseover="efeitoMouseOver_xs" @mouseleave="efeitoMouseLeave_xs">
        <div class="avatar-img-xs">
            <!--<img id="user-avatar-xs"
                :src="require('@/thumbler/' + usuario.foto)"
                alt="Avatar do Perfil" 
            />-->
            <b-img-lazy 
                    :src="require('@/thumbler/' + usuario.foto)" 
                    alt="Avatar do Perfil" 
                    id="user-avatar-xs">
            </b-img-lazy>
        </div>
        <i class="fas fa-angle-down" id="avatar-seta-xs"></i>
    </div>

    <div id="avatar-conteudo-xs" class="avatar-expand-xs" @mouseover="efeitoMouseOver_xs" @mouseleave="efeitoMouseLeave_xs">
        <div id="avatar-conteudo-header-xs" class="avatar-conteudo-header-fundo-xs" >
            <!--<img id="user-imagem-xs" class="avatar-header-thumbnail-xs"
                :src="require('@/thumbler/' + usuario.foto)"
                alt="Imagem de perfil do usuário"
            />-->
            <b-img-lazy 
                    :src="require('@/thumbler/' + usuario.foto)" 
                    alt="Imagem de perfil do usuário" 
                    class="avatar-header-thumbnail-xs"
                    id="user-imagem-xs">
            </b-img-lazy>
            <div id="avatar-nome-xs" class="avatar-header-titulo-xs">{{ limitaTitulo_xs }}</div>
            <div id="avatar-email-xs" class="avatar-header-email-xs">{{ limitaEmail_xs }}</div>
        </div>
        <span id="avatar-home-xs" class="avatar-conteudo-botao-xs" @click.prevent="goHome_xs">
            <i class="fas fa-house-user ml-2 mr-3"></i>Página inicial
        </span>
        <span id="avatar-perfil-xs" class="avatar-conteudo-botao-xs"><i class="far fa-address-card ml-2 mr-3"></i>Editar Perfil</span>
        <span id="avatar-config-xs" class="avatar-conteudo-botao-xs"><i class="fas fa-user-cog ml-2 mr-3"></i>Configurações</span>
        <span id="avatar-logoff-xs" class="avatar-conteudo-botao-xs" @click.prevent="logout_xs">
            <i class="fas fa-sign-out-alt ml-2 mr-3"></i>Sair
        </span>
    </div>

  </div>
</template>

<script>
import { userKey } from '../../global'
import { mapState } from 'vuex'
import { ekarApyaba } from '../../config/piht/cv.js'

export default {
    name: 'avatarSmall',
    props: {
        
    },
    components: { },
    computed: {
        ...mapState(['usuario']),
        limitaTitulo_xs: function () {
            const entrada = this.usuario.apelido ? this.usuario.apelido : this.usuario.nome_razao;
            let saida = '';
 
            if(entrada.length >= 15) {
                saida = entrada.substring(0, 14);
                saida += "...";
            } else saida = entrada;
            
            return saida
        },
        limitaEmail_xs: function () {
            const entrada = this.usuario.email
            let saida = '';
 
            if(entrada.length >= 18) {
                saida = entrada.substring(0, 17);
                saida += "...";
            } else saida = entrada;

            return saida
        }
    },
    data: function() {
        return {
            expandido_xs: false,
        }
    },
    methods: {
        expandirAvatar_xs() {
            this.expandido_xs = !this.expandido_xs;

            if (this.expandido_xs) {
                const alvo = document.getElementById("avatar-conteudo-xs");
                alvo.classList.add("expand-visivel-xs");
                
                const ctrlSeta = document.getElementById("avatar-seta-xs");
                ctrlSeta.classList.remove("fa-angle-down");
                ctrlSeta.classList.add("fa-angle-up");
                window.addEventListener('click', this.fecharClickExterno_xs);
            } else {
                const alvo = document.getElementById("avatar-conteudo-xs");
                alvo.classList.remove("expand-visivel-xs");
                
                const ctrlSeta = document.getElementById("avatar-seta-xs");
                ctrlSeta.classList.remove("fa-angle-up");
                ctrlSeta.classList.add("fa-angle-down");
                window.removeEventListener('click', this.fecharClickExterno_xs);
            }
        },
        efeitoMouseOver_xs() {
            const setaAvatar = document.getElementById("avatar-seta-xs");
            setaAvatar.style.transition = "all 1s";
            setaAvatar.style.color = "#008fac";
            const bordaAvatar = document.getElementById("user-avatar-xs");
            bordaAvatar.style.transition = "all 1s";
            bordaAvatar.style.border = "solid 2px #008fac";
        },
        efeitoMouseLeave_xs() {
            const setaAvatar = document.getElementById("avatar-seta-xs");
            setaAvatar.style.color = "#aaa";
            const bordaAvatar = document.getElementById("user-avatar-xs");
            bordaAvatar.style.border = "solid 2px #fff";
        },
        fecharClickExterno_xs() {
            if ( this.$mq === 'xs' ) {
                const alvo = document.getElementById("avatar-conteudo-xs");
                const botao = document.getElementById('avatar-main-id-xs');

                const ClickDentro = alvo.contains(event.target);
                const ClickBotao = botao.contains(event.target);

                if(!ClickBotao)   {  //so executa de clicou fora do botao
                    if(!ClickDentro) {
                        //Se clicou fora efetua o fechamento do menu avatar
                        alvo.classList.remove("expand-visivel-xs");
                        const ctrlSeta = document.getElementById("avatar-seta-xs");
                        ctrlSeta.classList.remove("fa-angle-up");
                        ctrlSeta.classList.add("fa-angle-down");
                        this.expandido_xs = false;
                        window.removeEventListener('click', this.fecharClickExterno_xs);
                    }
                }
            } else {
                this.expandido_xs = false;
                window.removeEventListener('click', this.fecharClickExterno_xs);
            }
        },
        logout_xs() {
            this.expandirAvatar_xs();
            localStorage.removeItem(userKey)
            this.$store.commit('setUser', null)
            this.$router.push({ name: 'Auth' })
        },
        goHome_xs() {
            this.expandirAvatar_xs(); //fecha menu
            ekarApyaba(this.usuario, this.$router.currentRoute.path);//executa acao de ctrl //////////
            this.$nextTick(function () {
                this.$store.commit('alternaMenu', false);
            });
        }
    }, 
}
</script>

<style>
.avatarSmall {
    position: relative;
    height: 50px;
    width: 50px;
}
.avatar-main-xs {
    margin: 0;
    height: 100%;
    width: 100%;
}
.avatar-main-xs:hover{
    cursor: pointer;
}

.avatar-img-xs {
    position: absolute;
    left: 0;
    top: 7px;
}

.avatar-img-xs > img {
    max-height: 36px;
    max-width: 36px;
    border-radius: 36px;
}

#avatar-seta-xs {
    position: absolute;
    top: 18px;
    left: 37px;
    color: #aaa;
}

.avatar-expand-xs {
    position: absolute;
    right: 5px;
    background-color: #fff;
    min-width: 280px;
    min-height: 277px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 6;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: hidden;
    text-align: left !important;

    visibility: hidden;
    opacity: 0;
    transition: visibility 0.5s, opacity 0.5s linear;
}

.expand-visivel-xs {
    visibility: visible;
    opacity: 1;
}
/* ***************************************************************/

/* Conteudo do cabeçalho do menu **********************************/
.avatar-conteudo-header-fundo-xs {
    background-image: url("../../assets/hion_18.png");
    background-color: #000;
    /*background-image: linear-gradient(to bottom right, #008fac , #004f5f);*/

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    /* Needed to position the navbar */
    position: relative;
    height: 100px;
    width: 280px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.avatar-header-thumbnail-xs {
    max-height: 72px;
    max-width: 72px;
    border-radius: 50px;
    margin-top: 14px;
    margin-left: 20px;
    box-shadow: 0px 2px 2px #2e2d2c;
}
.avatar-header-titulo-xs {
    text-decoration: none;
    max-height: 20px;
    max-width: 160px;
    margin-left: 10px;
    display: inline-block;
    color: #fff;
    text-shadow: 0px 2px 2px #000000;
    font-family: "Play", sans-serif;
    font-size: 17px;
}
.avatar-header-email-xs {
    text-decoration: none;
    max-height: 20px;
    max-width: 160px;
    margin-left: 102px;
    margin-top: -34px;
    color: #eee;
    font-family: Helvetica,Arial;
    font-size: 14px;
}
.avatar-conteudo-botao-xs {
    text-decoration: none;
    border:none;
    height: 43px;
    width: 280px;
    padding: .75rem 1.5rem;
    color: #2e2d2c;
    background-color: #fff;
}
.avatar-conteudo-botao-xs i {
    font-size: 19px;
}
.avatar-conteudo-botao-xs:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
    font-weight: bold;
}
.avatar-conteudo-botao-xs:hover i {
    color: #007188;
}
/* ***************************************************************/

</style>